import { getStaticMessage } from '@shared/utils';
import { StaticMessage } from '.';

export enum ImportExcelWarningType {
  LocationCategory,
  ActivityGroup,
  CustomData,
  ActivityStream,
  Activity,
  Location,
}
export function ImportExcelWarningTypeName(type: ImportExcelWarningType) {
  switch (type) {
    case ImportExcelWarningType.LocationCategory:
      return getStaticMessage(StaticMessage.WarningLocationCategory);
    case ImportExcelWarningType.ActivityGroup:
      return getStaticMessage(StaticMessage.WarningActivityGroup);
    case ImportExcelWarningType.CustomData:
      return getStaticMessage(StaticMessage.WarningCustomData);
    case ImportExcelWarningType.ActivityStream:
      return getStaticMessage(StaticMessage.WarningActivityStream);
    case ImportExcelWarningType.Activity:
      return getStaticMessage(StaticMessage.WarningActivity);
    case ImportExcelWarningType.Location:
      return getStaticMessage(StaticMessage.WarningLocation);
  }
}
